<template>
	<div class="wscn-http404-container">
		<div class="wscn-http404">
			<div class="pic-404">
				<img style="width:300px" src="@/assets/rslt-logo.png" class="user-avatar" />
			</div>
			<div class="errorPage">
				<template v-if="error">
					<div class="errorPage__oops">{{ errorTitle }}</div>
					<div class="errorPage__headline">{{ $t('integrations.exact') }}</div>
					<div class="errorPage__info">{{ errorMessage }}</div>
				</template>
				<template v-else>
					<div class="errorPage__oops">{{ $t('success') }}</div>
					<div class="errorPage__headline">{{ $t('integrations.exact') }}</div>
					<div class="errorPage__info">{{ $t('integrations.exact_registered_entities') }}</div>
					<ul class="entity-list">
						<li v-for="entity in legalEntities" :key="entity">{{ entity }}</li>
					</ul>
				</template>
				<el-button type="primary" @click="goToIntegrations">
					{{ $t('integrations.back_to_integrations') }}
				</el-button>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'ExactRedirect',
	data() {
		return {
			error: null,
			legalEntities: []
		};
	},
	computed: {
		errorTitle() {
			switch (this.error) {
				case 'critical_error':
					return this.$t('error.somethingWentWrong');
				case 'no_entities_found':
					return this.$t('integrations.exact_error_no_entities_title');
				default:
					return this.$t('error.somethingWentWrong');
			}
		},
		errorMessage() {
			switch (this.error) {
				case 'critical_error':
					return this.$t('integrations.exact_error_critical_error');
				case 'no_entities_found':
					return this.$t('integrations.exact_error_no_entities_found');
				default:
					return this.$t('integrations.exact_error_bad_request');
			}
		}
	},
	created() {
		const { query } = this.$route;

		if (query.error) {
			this.error = query.error;
		} else if (query.legal_entities_registered) {
			// Handle both array and single string
			this.legalEntities = Array.isArray(query.legal_entities_registered)
				? query.legal_entities_registered
				: [query.legal_entities_registered];
		}

		// Set error if no entities found
		if (!this.error && this.legalEntities.length === 0) {
			this.error = 'no_entities_found';
		}
	},
	methods: {
		goToIntegrations() {
			this.$router.push({ name: 'integrations' });
		}
	}
};
</script>

<style lang="scss" scoped>
.wscn-http404-container {
	transform: translate(-50%, -50%);
	position: absolute;
	top: 40%;
	left: 50%;
}
.wscn-http404 {
	position: relative;
	width: 1200px;
	padding: 0 50px;
	overflow: hidden;
	.pic-404 {
		text-align: center;
		position: relative;
		float: left;
		width: 600px;
		overflow: hidden;
	}
	.errorPage {
		position: relative;
		float: left;
		width: 300px;
		padding: 30px 0;
		overflow: hidden;
		&__oops {
			font-size: 32px;
			font-weight: bold;
			line-height: 40px;
			color: #1482f0;
			opacity: 0;
			margin-bottom: 20px;
			animation-name: slideUp;
			animation-duration: 0.5s;
			animation-fill-mode: forwards;
		}
		&__headline {
			font-size: 20px;
			line-height: 24px;
			color: #222;
			font-weight: bold;
			opacity: 0;
			margin-bottom: 10px;
			animation-name: slideUp;
			animation-duration: 0.5s;
			animation-delay: 0.1s;
			animation-fill-mode: forwards;
		}
		&__info {
			font-size: 13px;
			line-height: 21px;
			color: grey;
			opacity: 0;
			margin-bottom: 30px;
			animation-name: slideUp;
			animation-duration: 0.5s;
			animation-delay: 0.2s;
			animation-fill-mode: forwards;
		}
		.entity-list {
			font-size: 13px;
			line-height: 21px;
			color: grey;
			opacity: 0;
			margin-bottom: 30px;
			animation-name: slideUp;
			animation-duration: 0.5s;
			animation-delay: 0.3s;
			animation-fill-mode: forwards;
			list-style-type: disc;
			padding-left: 20px;
		}
		@keyframes slideUp {
			0% {
				transform: translateY(60px);
				opacity: 0;
			}
			100% {
				transform: translateY(0);
				opacity: 1;
			}
		}
	}
}
</style>
